import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Jee = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".vistasHeader");
      if (window.scrollY > 50) {
        header?.classList.add("smallHeader");
      } else {
        header?.classList.remove("smallHeader");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  var settings = {
    dots: false,
    infinite: true,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    autoplaySpeed: 2000,
    autoplay: true,
    slidesToScroll: 1,
  };
  return (
    <>
      <div className="vistasHeader">
        <div className="vistas-logo">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas-logo.png"
            className="img-fluid"
            alt="Lotus Valley School, Gurgaon"
          />
        </div>
        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? "✖" : "☰"}
        </div>

        <ul className={`vistas-menu ${menuOpen ? "open" : ""}`}>
          <li>
            <Link to="/vistas">Introduction</Link>
          </li>
          <li>
            <Link to="/counselling-vistas">Counselling</Link>
          </li>
          <li>
            <Link to="/upcomingevt-vistas">Upcoming Events</Link>
          </li>
          <li>
            <Link to="/update-vistas">Updates</Link>
          </li>
          <li>
            <Link to="/spotlight-vistas">Spotlight</Link>
          </li>
          <li>
            <Link to="/connect-vistas">Connect with Us</Link>
          </li>
        </ul>
      </div>
      <div className="slider-vistas">
        <Slider {...settings}>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas1.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas2.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas3.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas4.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas5.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas6.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas7.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas8.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
        </Slider>
      </div>
      <div className="padding-wid vistas_p">
        <div class="container">
          <div class="text-center d-block">
            <h3 class="mx-auto text-black mb-4 font-play">
              JOINT ENTRANCE EXAMINATION(JEE)
            </h3>
          </div>
          <div class="table">
            <table border="1" cellspacing="0" cellpadding="0" width="100%">
              <tbody>
                <tr>
                  <td colspan="2">
                    <strong>JEE Main 2024 Overview&nbsp; </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Particulars </strong>
                  </td>
                  <td>
                    <strong>Details </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Name of the Examination<strong> </strong>
                  </td>
                  <td>
                    Joint Entrance Examination Main (JEE Main)<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Conducting Body<strong> </strong>
                  </td>
                  <td>
                    National Testing Agency (NTA)<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Level of Examination<strong> </strong>
                  </td>
                  <td>
                    Undergraduate Exam at the National Level<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Exam Frequency<strong> </strong>
                  </td>
                  <td>
                    Twice a year (January and April)<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Exam Mode<strong> </strong>
                  </td>
                  <td>
                    Computed Based Test (CBT) for admissions to BE/ B.Tech/
                    B.Arch/ B.Plan Pen and paper-based test (PBT) for Drawing
                    section in B.Arch<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Courses Offered via Entrance Exam<strong> </strong>
                  </td>
                  <td>
                    BE/B.Tech, B.Arch, B.Plan<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>Mode of Application</td>
                  <td>Online</td>
                </tr>
                <tr>
                  <td>Exam Duration</td>
                  <td>
                    <ul>
                      <li>3 hours for B.Tech/ B.Arch/ B.Plan</li>
                      <li>3.5 hours for B.Arch and B.Planning both</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Papers and Total Marks</td>
                  <td>
                    <ul>
                      <li>Paper-1: BE/B.Tech (300 marks)</li>
                      <li>Paper-2A: B.Arch (400 marks)</li>
                      <li>Paper-2B: B.Plan (400 marks)</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Total Questions</td>
                  <td>
                    <ul>
                      <li>BE/B.Tech : 90</li>
                      <li>B.Arch: 82</li>
                      <li>B.Plan: 105</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Marking Scheme</td>
                  <td>
                    <ul>
                      <li>+4 for each correct response</li>
                      <li>-1 for each incorrect response</li>
                      <li>No marks for un-attempted questions</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Colleges Accepting Exam Score</td>
                  <td>
                    <ul>
                      <li>All NIT, IIITs, and CFTIs</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Official Website</td>
                  <td>jeemain.nta.nic.in</td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>JOINT ENTRANCE EXAMINATION(JEE)</strong>
            </p>
            <table border="1" cellspacing="0" cellpadding="0" width="100%">
              <tbody>
                <tr>
                  <td colspan="2">
                    <strong>JEE ADVANCED 2024 OVERVIEW </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Aspects </strong>
                  </td>
                  <td>
                    <strong>Information </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    JEE Advanced Full Form<strong> </strong>
                  </td>
                  <td>
                    Joint Entrance Exam (JEE) Advanced<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Frequency of Exam<strong> </strong>
                  </td>
                  <td>
                    Once a year<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Exam Level of JEE Advanced 2024<strong> </strong>
                  </td>
                  <td>
                    National Level<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Participating Colleges in JEE Advanced 2024
                    <strong> </strong>
                  </td>
                  <td>
                    27<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    JEE Advanced Paper 1 and 2 – Duration<strong> </strong>
                  </td>
                  <td>6 Hours </td>
                </tr>
                <tr>
                  <td>
                    Number of Seats<strong> </strong>
                  </td>
                  <td>
                    16,234 Seats<strong> </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="copyright-vistas">
        © 2024 All rights reserved with Lotus Valley School, Gurgaon
      </div>
    </>
  );
};
export default Jee;
